// src/js/components/quick-add.js
if (!customElements.get("quick-add-modal")) {
  class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.addEventListener("product-info:loaded", ({ target }) => {
        target.addPreProcessCallback(this.preventDuplicatedIDs.bind(this));
      });
    }
    hide(preventFocus = false) {
      const cartNotification = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      if (preventFocus) this.openedBy = null;
      super.hide();
    }
    preventDuplicatedIDs(productElement) {
      const sectionId = productElement.dataset.section;
      const oldId = sectionId;
      const newId = `quick-add-${sectionId}`;
      productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
      Array.from(productElement.attributes).forEach((attribute) => {
        if (attribute.value.includes(oldId)) {
          productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
        }
      });
      productElement.dataset.originalSection = sectionId;
    }
  }
  customElements.define("quick-add-modal", QuickAddModal);
}
